const Array_Stdev = (tab) => {
  let i,j,total = 0, mean = 0, diffSqredArr = [];

  for(i=0; i < tab.length; i+=1) {
    total+=tab[i];
  }

  mean = total/tab.length;

  for(j=0; j<tab.length; j+=1) {
    diffSqredArr.push(Math.pow((tab[j]-mean),2));
  }

  return ( Math.sqrt(diffSqredArr.reduce((firstEl, nextEl) => {
    return firstEl + nextEl;
  }) / tab.length) );  
}

export default Array_Stdev
